import React, { useState, useEffect } from 'react';
import BreakCrumbs from '../../components/BreakCrumbs';
import {
  Box,
  Paper,
  Grid,
  Typography,
  Button,
  Divider,
  TextField,
} from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import TableLoading from '../../components/TableLoading';
import { alertError } from '../../Util/Util';
import TableEmpty from '../../components/TableEmpty';
import { LIST_PAGE_COUNT } from '../../data/common';
import { trim } from 'lodash';
import moment from 'moment';
import { DatePicker } from '@material-ui/pickers';
import memberAPI from '../../middleware/memberAPI';
import UserPayingMemberTable from '../../components/MemberManagement/UserPayingMemberTable';
import Swal from 'sweetalert2';
import UserPayingMemberCouponModal from './UserPayingMemberCouponModal';
import UserPayingMemberTransferModal from './UserPayingMemberTransferModal';

const UserPayingMemberList = (props) => {
  const { match } = props;
  const [isLoading, setIsLoading] = useState(false);
  const [userPayingMembers, setUserPayingMembers] = useState();
  const [total, setTotal] = useState();
  const [pageNum, setPageNum] = useState(1);
  const [keyword, setKeyword] = useState('');
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [couponModalOpen, setCouponModalOpen] = useState(false);
  const [selectedUserPayingMember, setSelectedUserPayingMember] = useState(
    null,
  );
  const [transferModalOpen, setTransferModalOpen] = useState(false);
  const [transferUserPayingMember, setTransferUserPayingMember] = useState(
    null,
  );

  useEffect(() => {
    getUserPayingMembers();
  }, [pageNum]);

  const getUserPayingMembers = () => {
    setIsLoading(true);

    const startAt =
      trim(startDate) !== '' ? moment(startDate).format('YYYY-MM-DD') : '';

    const endAt =
      trim(endDate) !== '' ? moment(endDate).format('YYYY-MM-DD') : '';

    return memberAPI
      .getUserPayingMembers(pageNum, LIST_PAGE_COUNT, startAt, endAt, keyword)
      .then(
        (rs) => {
          if (rs.totalCount <= 0) {
            setUserPayingMembers(undefined);
            setTotal(0);
          } else {
            setUserPayingMembers(rs.memberTransactionList);
            setTotal(rs.totalCount);
          }
          return rs;
        },
        (error) => {
          alertError(error);
        },
      )
      .then((rs) => {
        setIsLoading(false);
        return rs;
      });
  };

  const handleKeyword = (e) => {
    const value = trim(e.target.value);

    setKeyword(value);
  };

  const handleSearch = () => {
    setPageNum(1);

    if (pageNum === 1) {
      getUserPayingMembers();
    }
  };

  const handleChangeStartDate = (e) => {
    setStartDate(e);
  };

  const handleChangeEndDate = (e) => {
    setEndDate(e);
  };

  const handleCancelPayingMember = (userPayingMemberId) => {
    Swal.fire({
      title: '確認取消',
      text: '確定要取消此VIP會員記錄嗎？',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: '確定',
      confirmButtonColor: '#d33',
      cancelButtonText: '取消',
    }).then((result) => {
      if (result.isConfirmed) {
        setIsLoading(true);

        memberAPI.cancelPayingMember(userPayingMemberId).then(
          () => {
            Swal.fire({
              toast: true,
              position: 'top-end',
              showConfirmButton: false,
              timer: 3000,
              title: '取消成功',
              icon: 'success',
            });
            getUserPayingMembers();
          },
          (error) => {
            alertError(error);
            setIsLoading(false);
          },
        );
      }
    });
  };

  const handleOpenCouponModal = (userPayingMember) => {
    setSelectedUserPayingMember(userPayingMember);
    setCouponModalOpen(true);
  };

  const handleCloseCouponModal = () => {
    setCouponModalOpen(false);
    setSelectedUserPayingMember(null);
  };

  const handleOpenTransferModal = (userPayingMember) => {
    setTransferUserPayingMember(userPayingMember);
    setTransferModalOpen(true);
  };

  const handleCloseTransferModal = () => {
    setTransferModalOpen(false);
    setTransferUserPayingMember(null);
  };

  const handleTransferSuccess = () => {
    getUserPayingMembers();
  };

  const handleCouponModalSuccess = () => {
    // 刷新列表以獲取最新資料
    getUserPayingMembers().then((rs) => {
      // 更新 modal 中的會員資料
      if (selectedUserPayingMember && rs && rs.memberTransactionList) {
        const updatedMember = rs.memberTransactionList.find(
          (member) => member.id === selectedUserPayingMember.id,
        );
        if (updatedMember) {
          setSelectedUserPayingMember(updatedMember);
        }
      }
    });
  };

  return (
    <div className="popular pagefadeIn">
      <BreakCrumbs path={match.url}></BreakCrumbs>

      <Box component={Paper} square elevation={2} p={1} mt={3} mb={3}>
        <Grid
          container
          direction="row"
          justify="space-around"
          alignItems="center">
          <Grid item xs>
            <Typography variant="h4" color="textPrimary" gutterBottom>
              VIP會員記錄
            </Typography>
          </Grid>
        </Grid>

        <Divider light />

        <Box textAlign="right" mt={2} mb={2}>
          <DatePicker
            autoOk
            label="開始時間"
            clearable
            disableFuture
            inputVariant="outlined"
            value={startDate || null}
            onChange={handleChangeStartDate}
            format="yyyy-MM-dd"
            size="small"
            style={{
              margin: '6px 12px 6px 0',
              width: '150px',
            }}
          />

          <DatePicker
            autoOk
            label="結束時間"
            clearable
            disableFuture
            inputVariant="outlined"
            value={endDate || null}
            onChange={handleChangeEndDate}
            format="yyyy-MM-dd"
            size="small"
            style={{
              margin: '6px 12px 6px 0',
              width: '150px',
            }}
          />

          <TextField
            label="手機/姓名 搜尋"
            type="search"
            variant="outlined"
            size="small"
            disabled={isLoading}
            value={keyword}
            onChange={handleKeyword}
            style={{ margin: '6px 12px 6px 0', width: '150px' }}
            onKeyUp={(e) => {
              if (e.key === 'Enter') {
                handleSearch();
              }
            }}
          />

          <Button
            variant="contained"
            color="primary"
            startIcon={<SearchIcon />}
            disabled={isLoading}
            onClick={handleSearch}
            style={{
              margin: '6px 12px 6px 0',
            }}>
            搜尋
          </Button>
        </Box>

        {isLoading && <TableLoading />}

        {!isLoading && !userPayingMembers && (
          <TableEmpty message="查無VIP會員記錄" />
        )}

        {!isLoading && userPayingMembers && (
          <UserPayingMemberTable
            userPayingMembers={userPayingMembers}
            total={total}
            pageNum={pageNum}
            setPageNum={setPageNum}
            onCancelPayingMember={handleCancelPayingMember}
            onOpenCouponModal={handleOpenCouponModal}
            onOpenTransferModal={handleOpenTransferModal}
          />
        )}
      </Box>

      <UserPayingMemberCouponModal
        open={couponModalOpen}
        userPayingMember={selectedUserPayingMember}
        onClose={handleCloseCouponModal}
        onSuccess={handleCouponModalSuccess}
      />

      <UserPayingMemberTransferModal
        open={transferModalOpen}
        userPayingMember={transferUserPayingMember}
        onClose={handleCloseTransferModal}
        onSuccess={handleTransferSuccess}
      />
    </div>
  );
};

export default UserPayingMemberList;
